<template>
    <DModal
        :title="__('customers.contracts.notes.edit')"
        is-confirm
        is-big
        :show="showModal || modalHasErrors"
        :is-awaiting-validation="true"
        @confirm="saveNotes"
        @close="$emit('close-modal')"
    >
        <div style="padding: 20px;">
            <DRow style="margin-top: 16px;">
                <DCol>
                    <Notes
                        v-model:notesInternal="noteForm.notes_internal"
                        v-model:notesInvoice="noteForm.notes_invoice"
                        :errors="errors"
                        :field-size="10"
                    />
                </DCol>
            </DRow>
        </div>
    </DModal>
</template>

<script>

import Notes from '~@/Components/Customers/Contracts/FormFields/Notes'

export default {
    name: 'EditNoteModal',
    components: {
        Notes
    },
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            noteForm: this.$inertia.form({
                id: this.contract.id,
                notes_invoice: this.contract.notes_invoice,
                notes_internal: this.contract.notes_internal
            }),
            errors: this.errorsData,
            modalHasErrors: false
        }
    },
    methods: {
        saveNotes () {
            this.noteForm.put(this.$route('customers.customers.contracts.update_notes', {
                customer: this.contract.customer_id,
                contract: this.contract.id
            }), {
                onSuccess: () => {
                    this.$emit('close-modal')
                    this.modalHasErrors = false
                },
                onError: (error) => {
                    this.errors = error
                    this.modalHasErrors = true
                }
            })
        }
    }
}
</script>
